<template>
	<div class="addActivityManagement">
		<el-card>
			<div class="jump-btn">
				<!-- 返回活动管理 -->
				<el-button type="primary" @click="jump()">{{$t('lang.btn_backActivity')}}</el-button>
			</div>
			<el-form :rules="rules" ref="form" :model="form" class="form" :label-width="require('@/config/enum').c_ws4"
				:label-suffix="require('@/config/enum').c_colon">
				<el-form-item :label="$t('lang.lab_garden')" prop="gardenId" v-if="id">
					<el-select v-model="form.gardenId" class="select">
						<el-option v-for="(item,index) in types" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<!-- 全局小区为全部小区时所属小区 -->
				<el-form-item :label="$t('lang.lab_garden')" prop="gardenIds" v-else>
					<el-select v-model="form.gardenIds" multiple @change="change" class="select" clearable filterable>
						<el-option key :label="$t('lang.villageall')" :value='0'></el-option>
						<el-option v-for="(item,index) in types" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<!-- 活动名称 -->
				<el-form-item :label="$t('lang.lab_activityName')" prop="name">
					<el-input v-model="form.name" :placeholder="$t('lang.key_name')" class="input"></el-input>
				</el-form-item>
				<!-- 活动核销码 -->
				<!-- <el-form-item label="活动核销码" prop="cerCode" v-if="this.id">
					<el-input v-model="form.cerCode" disabled class="input"></el-input>
				</el-form-item> -->
				<!-- 活动图片 -->
				<!-- <el-form-item :label="$t('lang.lab_image')" prop="image" ref="image">
					<upload-file ref="uploading" :accept='accept' upTypes='1' :fileList='fileList' :clears='clears' @outputFile="getFile"
						@removeFile='removeFile'></upload-file>
				</el-form-item> -->
				<!-- 活动开始、截止时间 -->
				<el-form-item :label="$t('lang.lab_beginTime')" prop="beginTime">
					<div class="block">
						<el-date-picker v-model="beginTimeList" :format="$t('lang.lab_DATA')" value-format="yyyy-MM-dd"
							type="daterange" :range-separator="$t('lang.lab_to')" :start-placeholder="$t('lang.lab_startDate')"
							:end-placeholder="$t('lang.lab_endDate')" :picker-options="pickerOptions0">
						</el-date-picker>
					</div>
				</el-form-item>
				<!-- 报名截止时间 -->
				<!-- <el-form-item :label="$t('lang.lab_closeTime')" prop="closeTime">
					<div class="block">
						<el-date-picker v-model="form.closeTime" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptions0"
							:format="$t('lang.lab_DATA')" :placeholder="$t('lang.lab_closeTime')"></el-date-picker>
					</div>
				</el-form-item> -->
				<!-- 活动地点 -->
				<el-form-item :label="$t('lang.lab_place')" prop="place">
					<el-input v-model="form.place" :placeholder="$t('lang.key_place')" class="input"></el-input>
				</el-form-item>
				<!-- 选择商品 -->
				<!-- <el-form-item :label="$t('lang.lab_goods')" prop="goodsLink">
					<el-select v-model="form.goodsLink" class="select" clearable filterable>
						<el-option v-for="(item,index) in goodsLinkList" :key="index" :label="item.goodName" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item> -->
				<!-- 总人数上限 -->
				<!-- <el-form-item :label="$t('lang.lab_totalNum')" prop="totalNum">
					<el-input v-model="form.totalNum" :placeholder="$t('lang.key_totalNum')" class="input" @input="keyTn" maxlength="6"></el-input>
				</el-form-item> -->
				<!-- 每家人数上限 -->
				<!-- <el-form-item :label="$t('lang.lab_eachNum')" prop="eachNum">
					<el-input v-model="form.eachNum" :placeholder="$t('lang.key_eachNum')" class="input" maxlength="6" @input="keyEn"></el-input>
				</el-form-item> -->
				<!-- 费用 -->
				<!-- <el-form-item :label="$t('lang.lab_cost')" prop="cost">
					<el-input v-model="form.cost" :placeholder="$t('lang.key_cost')" class="input" maxlength="4" @input="keyCo"></el-input>
				</el-form-item> -->
				<!-- 电话号码 -->
				<el-form-item :label="$t('lang.lab_telephone')" prop="telephone">
					<el-input v-model="form.telephone" :placeholder="$t('lang.key_tekephone')" class="input" maxlength="30"
						@input="keyTp"></el-input>
				</el-form-item>
				<!-- 首页显示 -->
				<!-- <el-form-item :label="$t('lang.lab_homeShow')" prop="homeShow">
					<el-radio v-model="form.homeShow" label="1">{{$t('lang.yes')}}</el-radio>
					<el-radio v-model="form.homeShow" label="0">{{$t('lang.no')}}</el-radio>
				</el-form-item> -->
				<!-- 绑定投票 -->
				<!-- <el-form-item :label="$t('lang.lab_isRelatedVote')">
					<el-radio v-model="voteIsShow" label="1">{{$t('lang.yes')}}</el-radio>
					<el-radio v-model="voteIsShow" label="0">{{$t('lang.no')}}</el-radio>
				</el-form-item> -->
				<!-- 投票下拉列表 -->
				<!-- <el-form-item :label="$t('lang.lab_choiceVote')" v-if="this.voteIsShow==1" prop="voteList">
					<el-select v-model="voteId" :placeholder="$t('lang.lab_please_Select')">
						<el-option v-for="(item,index) in voteList" :key="index" :label="item.content" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item> -->
				<!-- 排序 -->
				<!-- <el-form-item :label="$t('lang.lab_orderBy')" prop="orderBy">
					<el-input v-model="form.orderBy" controls-position="right" :min="1" class="input" @input="keyOb" maxlength="4"></el-input>
				</el-form-item> -->
				<!-- 通知正文 -->
				<el-form-item label="活动简介" prop="content">
					<!-- 富文本 -->
					<quill-editor v-model="form.content" ref="myQuillEditor" :options="editorOption"
						@change="onEditorChange($event)"></quill-editor>
					<span
						class="editorText">{{$t('lang.lab_editor_tip1')}}{{isLength}}{{$t('lang.lab_editor_tip2')}}{{10000-isLength}}{{$t('lang.lab_editor_tip3')}}</span>
				</el-form-item>
				<el-button @click="rest('form')" class="btn-first">{{$t('lang.btn_rest')}}</el-button>
				<el-button type="primary" @click="onSubmit('form')" class="detailbtn" :disabled="isDisabled">
					{{$t('lang.btn_save')}}</el-button>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	/**
	 *@ClassName:addActivityManagement
	 *@Description:添加活动管理
	 *@author:刘彦辰
	 *@Copyright:格众科技
	 *@date:2020-02-19
	 */
	// 引入富文本功能键tooltip效果
	import UploadFile from '../../../components/upload_file.vue'
	import {
		addQuillTitle
	} from '../../../config/quill-title.js'
	export default {
		data() {
			var positiveInteger = /^[0-9]*[0-9][0-9]*$/
			var positiveIntegerChenk = (rule, value, callback) => {
				if (value === '') {
					callback(new Error(this.$i18n.t('lang.key_appOrderBy')))
				} else {
					if (!positiveInteger.test(value)) {
						callback(new Error(this.$i18n.t('lang.key_appOrderBy')))
					}
					callback()
				}
			}
			var positiveInteger1 = /^[0-9]*[1-9][0-9]*$/
			var positiveIntegerChenk1 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error(this.$i18n.t('lang.key_appOrderBy')))
				} else {
					if (!positiveInteger1.test(value)) {
						callback(new Error(this.$i18n.t('lang.key_appOrderBy')))
						// callback()
					}
					callback()
				}
			}
			var phone = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/
			var telephone = (rule, value, callback) => {
				if (value === '') {
					callback(new Error(this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_telephone')))
				} else {
					if (!phone.test(value)) {
						callback(new Error(this.$i18n.t('lang.lab_inputDutyPersonPhoneIsTrue')))
					}
					callback()
				}
			}
			var isImage = (rule, value, callback) => {
				if (this.form.image === '') {
					callback(new Error(this.$i18n.t('lang.lab_pleaseSeletcUploadDoc')))
				} else {
					callback()
				}
			}
			var isBeginTime = (rule, value, callback) => {
				if (this.beginTimeList.length < 2) {
					callback(new Error(this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_beginTime')))
				} else {
					callback()
				}
			}
			var changeGardenIds = (rule, value, callback) => {
				if (this.form.gardenIds.length < 1) {
					callback(new Error(this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_garden')))
				} else {
					callback()
				}
			}
			var voteListValidator = (rule, value, callback) => {
				if (this.voteIsShow == 1) {
					if (this.voteId === '') {
						callback(new Error(this.$i18n.t('lang.lab_chanceVote')))
					} else {
						callback()
					}
				} else {
					callback()
				}
			}
			return {
				clears: false, // 清空按钮
				accept: '.jpg, .jpeg, .png',
				pickerOptions0: {
					disabledDate(time) {
						return time.getTime() < Date.now() - 8.64e7
					}
				}, // 当前时间
				activity_allGardenId: 0,
				goodsLinkList: '', // 选择商品
				saveData: '',
				id: '', // 区分新增和修改
				oldsearchUnit: [], // 复选输入框change前的数据
				total: 0, // 页容
				pageNum: 1, // 页数
				pageSize: 10, // 一页显示数
				isDisabled: true, // 置灰标识
				tableData: [], // 列表
				showSelect: true, // 显示标识
				isLength: 0, // 长度
				types: [], // 下拉列表
				value: '0', // 绑定值
				input: '', // input绑定值
				editorOption: {
					modules: {
						toolbar: [
							['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
							['blockquote', 'code-block'], // 引用，代码块
							[{
								header: 1
							}, {
								header: 2
							}], // 标题，键值对的形式；1、2表示字体大小
							[{
								list: 'ordered'
							}, {
								list: 'bullet'
							}], // 列表
							[{
								script: 'sub'
							}, {
								script: 'super'
							}], // 上下标
							[{
								indent: '-1'
							}, {
								indent: '+1'
							}], // 缩进
							[{
								direction: 'rtl'
							}], // 文本方向
							[{
								size: ['small', false, 'large', 'huge']
							}], // 字体大小
							[{
								header: [1, 2, 3, 4, 5, 6, false]
							}], // 几级标题
							[{
								color: []
							}, {
								background: []
							}], // 字体颜色，字体背景颜色
							[{
								font: []
							}], // 字体
							[{
								align: []
							}], // 对齐方式
							['clean'], // 清除字体样式
							['image', 'video'] // 上传图片、上传视频
						]
					},
					theme: 'snow',
					placeholder: this.$i18n.t('lang.lab_text'),
				}, // 富文本
				form: {
					gardenIds: [],
					gardenId: '',
					image: '',
					name: '',
					content: '',
					beginTime: '',
					endTime: '',
					place: '',
					goodsLink: '',
					totalNum: '',
					eachNum: '',
					cost: '',
					telephone: '',
					closeTime: '',
					homeShow: '1',
					orderBy: '1'
				}, // 对象

				voteIsShow: '0', // 是否显示投票下拉列表
				voteList: [], // 投票列表
				voteId: '',
				voteCount: '',
				voteShowFix: '', // 修改活动投票时固定值  监听用

				beginTimeList: [], // 开始时间
				fileList: [], // fileList
				rules: {
					gardenId: [{
						required: true,
						message: this.$i18n.t('lang.lab_chooseGarden'),
						trigger: 'change'
					}],
					gardenIds: [{
						required: true,
						validator: changeGardenIds,
						trigger: 'change'
					}],
					name: [{
						required: true,
						message: this.$i18n.t('lang.key_name'),
						trigger: 'blur'
					}],
					content: [{
						required: true,
						message: this.$i18n.t('lang.lab_InputcontentNotice'),
						trigger: 'blur'
					}],
					place: [{
						required: true,
						message: this.$i18n.t('lang.key_place'),
						trigger: 'blur'
					}],
					// totalNum: [{
					// 	required: true,
					// 	validator: positiveIntegerChenk,
					// 	trigger: 'blur'
					// }],
					// eachNum: [{
					// 	required: true,
					// 	validator: positiveIntegerChenk,
					// 	trigger: 'blur'
					// }],
					// cost: [{
					// 	required: true,
					// 	message: this.$i18n.t('lang.key_cost'),
					// 	trigger: 'blur'
					// }],
					telephone: [{
						required: true,
						validator: telephone,
						trigger: 'blur'
					}],
					// closeTime: [{
					// 	required: true,
					// 	message: this.$i18n.t('lang.lab_closeTime'),
					// 	trigger: 'blur'
					// }],
					// homeShow: [{
					// 	required: true,
					// 	message: this.$i18n.t('lang.key_apptype'),
					// 	trigger: 'blur'
					// }],
					// orderBy: [{
					// 	required: true,
					// 	validator: positiveIntegerChenk1,
					// 	trigger: 'blur'
					// }],
					// image: [{
					// 	required: true,
					// 	validator: isImage,
					// 	trigger: 'blur'
					// }],
					beginTime: [{
						required: true,
						validator: isBeginTime,
						trigger: 'blur'
					}],
					// voteList: [{
					// 	required: true,
					// 	validator: voteListValidator,
					// 	trigger: 'blur'
					// }]
				} // 表单验证
			}
		},
		components: {
			'upload-file': UploadFile
		},
		destroyed() {
			window.localStorage.setItem('addActivityManagementform', JSON.stringify(this.form))
			window.localStorage.setItem('addActivityManagementsaveData', JSON.stringify(this.saveData))
		},
		created() {
			this.id = this.$route.query.id
			if (window.localStorage.getItem('addActivityManagementform')) {
				this.form = JSON.parse(window.localStorage.getItem('addActivityManagementform'))
				if (this.form.image) {
					this.fileList.push({
						name: '',
						url: this.form.image
					})
				}
				if (this.$route.query.id) {
					let newTypes = [...this.$store.getters.userGardenList]
					let index = newTypes.findIndex(item => item.id === 0)
					if (index != -1) {
						newTypes.splice(index, 1)
					}
					this.types = newTypes
				} else {
					this.gardens()
				}
				if (window.localStorage.getItem('addActivityManagementsaveData')) {
					this.saveData = JSON.parse(window.localStorage.getItem('addActivityManagementsaveData'))
				}
			} else {
				if (this.$route.query.id) {
					this.activityById()
					this.getVoteByCount() // 修改页面查询
					let newTypes = [...this.$store.getters.userGardenList]
					let index = newTypes.findIndex(item => item.id === 0)
					if (index != -1) {
						newTypes.splice(index, 1)
					}
					this.types = newTypes
				} else {
					this.gardens()
				}
			}
			this.getAppletsGood()
			this.getVoteList()
		},
		computed: {
			editor() {
				return this.$refs.myQuillEditor.quill
			},
		},
		watch: {
			form: {
				handler(newVal, oldVal) {
					let tempRule = JSON.stringify(newVal)
					if (tempRule === this.saveData) {
						this.isDisabled = true
					} else {
						this.isDisabled = false
					}
				},
				deep: true,
				immediate: true
			},
			beginTimeList: {
				handler(newVal, oldVal) {
					if (newVal != oldVal) {
						this.isDisabled = false
					}
				},
				deep: true,
				immediate: true
			},
			/* voteIsShow: {
				deep: true,
				// immediate: true,
				handler(newVal, oldVal) {
					let val = this.voteShowFix
					if (val != newVal) {
						this.isDisabled = true
					} else {
						this.isDisabled = false
					}
				}
			}, */
			voteId(val) {
				if (!val) {
					this.isDisabled = true
				} else {
					this.isDisabled = false
				}
			},
			voteIsShow(val) {
				let voteShow = this.voteShowFix
				if (val == voteShow) {
					this.isDisabled = true
				} else {
					this.isDisabled = false
				}
			}
		},
		methods: {
			getAppletsGood() {
				let params = {
					gardenId: this.$store.state.gardenId,
					pageNo: 1,
					pageSize: 9999
				}
				let loading = this.$loading()
				this.$get(`/appletsGoodList/`, params).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.goodsLinkList = res.list
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},
			// 获取组件值
			getFile(e) {
				this.form.image = e
				this.$refs.image.clearValidate()
			},
			// 移除图片
			removeFile(e) {
				this.fileList = []
				this.form.image = ''
			},
			// 内容字数提示
			onEditorChange(event) {
				event.quill.deleteText(10000, 4)
				if (this.form.content == '') {
					this.isLength = 0
				} else {
					this.isLength = event.quill.getLength() - 1
				}
				this.manualValidate()
			},
			// 富文本验证
			manualValidate() {
				this.$refs.form.validateField('content')
			},
			// 排序输入限制数字
			keyOb() {
				// 仅保留数字和"."
				this.form.orderBy = this.form.orderBy.replace(/[^\d]/g, '')
				// 首位是0的话去掉
				if (this.form.orderBy.indexOf('.') < 0 && this.form.orderBy != '') {
					this.form.orderBy = parseFloat(this.form.orderBy)
				}
			},
			// 总人数上线限制数字
			keyTn() {
				// 仅保留数字和"."
				this.form.totalNum = this.form.totalNum.replace(/[^\d]/g, '')
				// 首位是0的话去掉
				if (this.form.totalNum.indexOf('.') < 0 && this.form.totalNum != '') {
					this.form.totalNum = parseFloat(this.form.totalNum)
				}
			},
			// 每家人数上限限制数字
			keyEn() {
				// 仅保留数字和"."
				this.form.eachNum = this.form.eachNum.replace(/[^\d]/g, '')
				// 首位是0的话去掉
				if (this.form.eachNum.indexOf('.') < 0 && this.form.eachNum != '') {
					this.form.eachNum = parseFloat(this.form.eachNum)
				}
			},
			// 费用限制为小数或数字
			keyCo() {
				// 仅保留数字和"."
				this.form.cost = this.form.cost.replace(/[^\d.]/g, '')
				// 两个连续的"."仅保留第一个"."
				this.form.cost = this.form.cost.replace(/\.{2,}/g, '.')
				// 去除其他"."
				this.form.cost = this.form.cost.replace('.', '$#*').replace(/\./g, '').replace('$#*', '.')
				// 首位是0的话去掉
				if (this.form.cost.indexOf('.') < 0 && this.form.cost != '') {
					this.form.cost = parseFloat(this.form.cost)
				}
			},
			// 联系电话限制数字
			keyTp() {
				// 仅保留数字和"."
				this.form.telephone = this.form.telephone.replace(/[^\d]/g, '')
				// 首位是0的话去掉
				if (this.form.telephone.indexOf('.') < 0 && this.form.telephone != '') {
					this.form.telephone = parseFloat(this.form.telephone)
				}
			},
			// 修改查询详情对象
			activityById() {
				let loading = this.$loading()
				this.$get(`/activityById/` + this.id).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.form = res.activity
							this.beginTimeList.push(this.form.beginTime)
							this.beginTimeList.push(this.form.endTime)
							if (res.activity.image && res.activity.image != '') {
								this.fileList.push({
									name: '',
									url: res.activity.image.toString()
								})
							}
							this.form.gardenId = res.activity.gardenId
							if (this.form.goodsLink != '' && this.form.goodsLink != undefined) {
								this.form.goodsLink = parseInt(this.form.goodsLink)
							}
							this.form.homeShow = this.form.homeShow.toString()
							this.saveData = JSON.stringify(this.form)
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},
			// 选择全部小区
			change(val) {
				const allValues = []
				allValues.push(0)
				for (const item of this.types) {
					allValues.push(item.id)
				}
				// 用来储存上一次选择的值，可进行对比
				const oldVal = this.oldsearchUnit.length === 1 ? this.oldsearchUnit[0] : []
				// 若选择全部
				if (val.includes(0)) {
					this.form.gardenIds = allValues
				}
				// 取消全部选中， 上次有， 当前没有， 表示取消全选
				if (oldVal.includes(0) && !val.includes(0)) {
					this.form.gardenIds = []
				}
				// 新老数据都有全部选中,那就说明除了全选以外的被选择，所以去掉全选
				if (oldVal.includes(0) && val.includes(0)) {
					const index = val.indexOf(0)
					val.splice(index, 1)
					this.form.gardenIds = val
				}
				// 全选未选，但是其他选项都全部选上了，则全选选上
				if (!oldVal.includes(0) && !val.includes(0)) {
					if (val.length === allValues.length - 1) {
						this.form.gardenIds = [0].concat(val)
					}
				}
				// 储存当前选择的最后结果 作为下次的老数据
				this.oldsearchUnit[0] = this.form.gardenIds
			},
			// 小区下拉
			gardens() {
				let loading = this.$loading()
				this.$get(`/gardens`).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.types = res.list
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},
			// 获取投票列表
			getVoteList() {
				let param = {
					gardenId: this.$store.getters.gardenId,
					pageNo: 1,
					pageSize: 999
				}
				this.$post(`/vote/voteList`, param)
					.then(res => {
						this.voteList = res.list
					})
					.catch(err => {
						this.$message.error(err)
					})
			},
			// 查询是否有投票
			getVoteByCount() {
				let params = {
					parentId: this.id
				}
				this.$post(`/voteRelation/selectRelationCount`, params).then(
					res => {
						if (res && res.errCode === 0) {
							this.voteCount = res.result
							if (res.result === 1) {
								this.$post(`/voteRelation/selectRelationEntity`, params).then(
									res => {
										if (res && res.errCode === 0) {
											this.voteId = res.result.voteId
											this.voteShowFix = '1'
											this.voteIsShow = '1'
										}
									},
									error => {
										this.$message.error(error)
									}
								)
							}
						}
					},
					error => {
						this.$message.error(error)
					}
				)
			},
			rest(form) {
				this.fileList = []
				this.clears = true
				this.$refs.form.clearValidate()
				this.beginTimeList = []
				this.form.name = ''
				this.form.beginTime = ''
				this.form.place = ''
				this.form.totalNum = ''
				this.form.eachNum = ''
				this.form.cost = ''
				this.form.telephone = ''
				this.form.closeTime = ''
				this.form.homeShow = '1'
				this.form.orderBy = '1'
			},
			jump() {
				this.$router.push({
					name: 'teachGroupList'
				})
			},
			onSubmit(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						if (this.id === '' || this.id === undefined) {
							if (this.form.gardenIds.includes(0)) {
								this.form.gardenIds.splice(0, 1)
							}
							if (this.form.gardenIds.length < 1) {
								this.$message.error(this.$i18n.t('lang.lab_chooseGarden'))
							} else {
								let formData = new FormData()
								formData.append('garden[]', this.form.gardenIds)
								formData.append('image', this.form.image)
								formData.append('name', this.form.name)
								formData.append('content', this.form.content)
								formData.append('beginTime', this.beginTimeList[0])
								formData.append('endTime', this.beginTimeList[1])
								formData.append('place', this.form.place)
								formData.append('totalNum', this.form.totalNum)
								formData.append('eachNum', this.form.eachNum)
								formData.append('cost', this.form.cost)
								formData.append('telephone', this.form.telephone)
								formData.append('closeTime', this.form.closeTime)
								formData.append('homeShow', this.form.homeShow)
								formData.append('orderBy', this.form.orderBy)
								let params = {
									'garden[]': this.form.gardenIds.toString(),
									image: 'https://oss.kmyhwy.cn/2025/03/20/03bd6261-7b7a-4b8c-a3f6-56adfaaba5e6.png',
									name: this.form.name,
									content: this.form.content,
									beginTime: this.beginTimeList[0],
									endTime: this.beginTimeList[1],
									place: this.form.place,
									goodsLink: this.form.goodsLink,
									totalNum: 0,
									eachNum: 0,
									cost: 0,
									telephone: this.form.telephone,
									closeTime: this.beginTimeList[1],
									homeShow: this.form.homeShow,
									orderBy: this.form.orderBy
								}
								let loading = this.$loading()
								this.$post(`/activity`, params)
									.then(res => {
											if (res && res.errCode === 0) {
												var index = this.$keepAlive.indexOf('/manage/main.teachGroupList')
												if (index > -1) {
													this.$keepAlive.splice(index, 1)
												}
												this.$message.success(this.$i18n.t('lang.lab_save_success'))
												this.$router.push({
													name: 'teachGroupList'
												})
											}
										},
										error => {
											loading.close()
											this.$message.error(error)
										}
									)
							}
						} else {
							if (this.form.gardenId === 0) {
								this.$message.error(this.$i18n.t('lang.lab_chooseGarden'))
							} else {
								let params = {
									gardenId: this.form.gardenId,
									image: 'https://oss.kmyhwy.cn/2025/03/20/03bd6261-7b7a-4b8c-a3f6-56adfaaba5e6.png',
									name: this.form.name,
									content: this.form.content,
									beginTime: this.beginTimeList[0],
									endTime: this.beginTimeList[1],
									place: this.form.place,
									goodsLink: this.form.goodsLink,
									totalNum: 0,
									eachNum: 0,
									cost: 0,
									telephone: this.form.telephone,
									closeTime: this.beginTimeList[1],
									homeShow: this.form.homeShow,
									orderBy: this.form.orderBy
								}
								let loading = this.$loading()
								this.$patch(`/activity/${this.id}`, params).then(
									res => {
										if (res && res.errCode === 0) {
											var index = this.$keepAlive.indexOf('/manage/main.teachGroupList')
											if (index > -1) {
												this.$keepAlive.splice(index, 1)
											}
											this.$router.push({
												name: 'teachGroupList'
											})
										}
									},
									error => {
										loading.close()
										this.$message.error(error)
									}
								)
							}
						}
					}
				})
			}
		},
		// 调用富文本方法生效
		mounted() {
			addQuillTitle()
		}
	}
</script>

<style lang="scss">
	.addActivityManagement {
		.input {
			width: 30%;
		}

		.el-form-item__content {
			width: 60vw !important;
		}

		.select {
			width: 30%;
		}
	}
</style>